import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { OWNERS } from "../data/mockData";
import { toast } from "sonner";
import { useState } from "react";

export function AddPropertyModal({ open, onOpenChange }) {
  const [form, setForm] = useState({
    name: "",
    address: "",
    city: "Palma",
    country: "Mallorca",
    ownerId: OWNERS[0].id,
  });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.address) {
      toast.error("Please provide a name and address.");
      return;
    }
    toast.success(`Property "${form.name}" queued for onboarding (simulated).`);
    onOpenChange(false);
    setForm({ name: "", address: "", city: "Palma", country: "Mallorca", ownerId: OWNERS[0].id });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="add-property-modal"
        className="sm:max-w-lg bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800"
      >
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight text-slate-900 dark:text-slate-50">
            Add a new property
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-500 dark:text-slate-400">
            Prototype form — nothing is saved. It's used to demo the onboarding flow.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={submit} className="space-y-4 pt-2">
          <div>
            <Label htmlFor="p-name" className="text-xs uppercase tracking-widest text-slate-500">
              Property name
            </Label>
            <Input
              id="p-name"
              data-testid="add-property-name-input"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="e.g. Villa Formentor"
              className="mt-1"
            />
          </div>
          <div>
            <Label htmlFor="p-address" className="text-xs uppercase tracking-widest text-slate-500">
              Street address
            </Label>
            <Input
              id="p-address"
              data-testid="add-property-address-input"
              value={form.address}
              onChange={(e) => setForm({ ...form, address: e.target.value })}
              placeholder="Street, number"
              className="mt-1"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-xs uppercase tracking-widest text-slate-500">City</Label>
              <Input
                data-testid="add-property-city-input"
                value={form.city}
                onChange={(e) => setForm({ ...form, city: e.target.value })}
                className="mt-1"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-slate-500">Country</Label>
              <Select
                value={form.country}
                onValueChange={(v) => setForm({ ...form, country: v })}
              >
                <SelectTrigger data-testid="add-property-country-select" className="mt-1">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Mallorca">Mallorca</SelectItem>
                  <SelectItem value="Ibiza">Ibiza</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div>
            <Label className="text-xs uppercase tracking-widest text-slate-500">Owner</Label>
            <Select value={form.ownerId} onValueChange={(v) => setForm({ ...form, ownerId: v })}>
              <SelectTrigger data-testid="add-property-owner-select" className="mt-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {OWNERS.map((o) => (
                  <SelectItem key={o.id} value={o.id}>
                    {o.name} — {o.company}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <DialogFooter className="pt-2">
            <Button
              type="button"
              variant="outline"
              data-testid="add-property-cancel-btn"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              data-testid="add-property-submit-btn"
              className="bg-slate-900 hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-white text-white"
            >
              Queue onboarding
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
